export default "__VITE_ASSET__w4$QVplW__"